module.exports = __webpack_public_path__ + "static/media/20ECE15.9208339c.jpg";